export default "__VITE_ASSET__QjEoMR7l__"